import { Box, Typography } from "@mui/material";

function PreviewHeader() {
  return (
    <Box
      sx={{
        mb: 1,
        px: 2,
        py: 1.2,
        borderRadius: 2,
        background: "linear-gradient(90deg, #e3f2fd, #bbdefb)",
        boxShadow: 2,
      }}
    >
      <Typography
        component="h2"
        sx={{
          fontSize: { xs: "16px", md: "18px" },
          fontWeight: 700,
          color: "#0d47a1",
          textAlign: "center",
        }}
      >
        Biodata Live Preview
      </Typography>

      <Typography
        sx={{
          fontSize: "12px",
          color: "#37474f",
          textAlign: "center",
          mt: 0.5,
        }}
      >
        Preview updates instantly as you fill the form
      </Typography>
    </Box>
  );
}

export default PreviewHeader;
